// AJAX usuwanie zdjęć galerii posiłków.
// Delegacja zdarzeń na document - działa też w formularzach ładowanych dynamicznie (offcanvas).
// Buttony muszą mieć klasę .ajax-purge-image i atrybut data-url z endpointem DELETE.

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.ajax-purge-image')
  if (!btn) return

  e.preventDefault()

  const confirmed = typeof window.bootstrapConfirm === 'function'
    ? await window.bootstrapConfirm('Usunąć to zdjęcie?')
    : confirm('Usunąć to zdjęcie?')

  if (!confirmed) return

  const url = btn.dataset.url
  if (!url) return

  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''

  btn.disabled = true
  btn.style.opacity = '0.5'

  try {
    const resp = await fetch(url, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': token,
        'Accept': 'application/json'
      }
    })

    if (resp.ok) {
      const wrapper = btn.closest('.gallery-image-wrapper')
      if (wrapper) {
        wrapper.style.transition = 'opacity 0.3s, transform 0.3s'
        wrapper.style.opacity = '0'
        wrapper.style.transform = 'scale(0.8)'
        setTimeout(function () {
          const parent = wrapper.parentElement
          parent.remove()

          const gallery = document.querySelector('.row.g-2.mb-3, .row.g-2.mb-2, .row.g-1.mb-2')
          if (gallery && gallery.children.length === 0) {
            gallery.remove()
          }
        }, 300)
      }
    } else {
      btn.disabled = false
      btn.style.opacity = ''
      alert('Błąd usuwania zdjęcia.')
    }
  } catch (_err) {
    btn.disabled = false
    btn.style.opacity = ''
    alert('Błąd sieci. Spróbuj ponownie.')
  }
})
